import { createGlobalState } from "react-hooks-global-state";
import { ACTIONS, } from "../components/Vault/VaultActionsForm/Modal/types";
export var initialVaultActionForm = {
    vaultVersion: "v1",
    inputAmount: "",
    // Default to deposit
    actionType: ACTIONS.deposit,
};
export var initialState = {
    vaultActionForm: initialVaultActionForm,
};
export var useWebappGlobalState = createGlobalState(initialState).useGlobalState;
//# sourceMappingURL=store.js.map